module.exports = __webpack_public_path__ + "img/macadam.95ff36e2.jpeg";